import { ValuesOf } from '../common/miscUtils.types';

export const routes = {
  root: '/',
  dashboardHome: '/dashboard/home',
  conversations: '/conversations',
  outlet: '/outlet',
  changePassword: '/changePassword',
  protectedPathTest: '/protectedPathTest',
  withDataStorageTest: '/withDataStorageTest',
  error: 'error',
  vehicleSelect: '/vehicleSelect',
  productFamilySelectionPage: '/productFamilySelectionPage',
  newQuote: '/newQuote',
  dashboardQuotes: '/dashboardQuotes',
  financialProduct: '/newQuote/financialProduct',
  saveAndContinueLanding: '/continue',
  saveAndContinueTanValidate: '/continue/validation',
  saveAndContinueExpired: '/continue/expired',
  search: '/search',
  oldFinancialProductPage: '/financialProductPage',
  dealerSummaryPage: '/newQuote/dealerSummary',
} as const;

export type TRoutesValues = ValuesOf<typeof routes>;
export type TRoutesKeys = keyof typeof routes;

export const isOutletSelectionRoute = () => {
  return window.location.pathname === routes.root;
};
